(function (appComponents) {

	appComponents.prototypes.component = function () {

		var protoComponent = {
			_getService: function (componentName) {
				return app.components.getService(componentName);
			},
			_getPageComponent: function (componentName) {
				return app.components.getPageComponent(this, componentName);
			},
			get _page() {
				return app.currentPage;
			},
			get _controller() {
				return app.currentController;
			},
			get _queryData() {
				var queryParams = app.router.params;
				var queryData = app.utils.parseQueryParams(queryParams);
				return queryData;
			}
		};

		protoComponent._elements = {
			get document() {
				return $(document);
			},
			get body() {
				return $('body');
			},
			get header() {
				return $('[pc-container="header"]');
			},
			get page() {
				return $('[pc-container="page"]');
			},
			get footer() {
				return $("[pc-container='footer']");
			},
			get modals() {
				return $('[pc-container="modals"]');
			}
		};


		protoComponent._applyScript = app.applyScript;
		protoComponent._stash = app.stash;
		protoComponent._config = app.config;
		protoComponent._api = app.api;
		protoComponent._utils = app.utils;
		protoComponent._events = app.core.events;
		protoComponent._handlers = app.core.handlers;
		protoComponent._pages = app.pages;
		protoComponent._currentPage = app.currentPage;
		protoComponent._messages = app.constants.messages;
		protoComponent._links = app.constants.links;
		protoComponent._url = app.constants.url;
		protoComponent._role = app.role;
		protoComponent._breadcrumbs = app.core.breadcrumbs;


		protoComponent.context = {
			role: app.role,
			flags: app.role.flags,
			config: app.config,
			user: app.config.user,
			links: app.constants.links,
			emails: app.constants.emails
		};

		protoComponent._bindings = function () {
			if (this.bindingsInitialized) {
				if (this.liveBindings != null) this.liveBindings();
				return;
			}

			this.bindings();

			if (this.liveBindings != null) this.liveBindings();

			this.bindingsInitialized = true;

		};

		protoComponent._updateUrlQuery = function (action, data) {

			app.core.handlers.onUpdateQuery(action, data);

		};

		protoComponent._updateUrlQueryWithPagerData = function (action, component) {
			if (!component) {
				component = this;
			}
			var pagerData = {
				pageNumber: component.pager.pageToSet,
				resultsPerPage: component.pager.pageSize
			};

			var qData = $.extend({}, this._queryData, pagerData);

			app.core.handlers.onUpdateQuery(action, qData);

		};

		protoComponent._scrollToTop = function () {
			window.scroll(0, 0);
		};

		protoComponent._scrollTo = function (elementToScroll) {
			this._elements.body.animate({
				scrollTop: elementToScroll.offset().top
			}, 2000);
		};

		protoComponent._goToPage = function (pageTitle) {
			var page = app.utils.findPageByTitle(pageTitle);
			app.core.handlers.onSwitchToPage(page);
		};

		protoComponent._goToPath = function (path) {
			app.core.handlers.onGoTo(path);
		};

		protoComponent._goBackInHistory = function () {
			app.core.handlers.onGoBack();
		};

		protoComponent._reload = function () {
			window.location.reload(true);
		};

		protoComponent._isRoleType = function (roleType) {
			if (app.role.type == roleType) {
				return true;
			} else {
				return false;
			}
		};

		// rewrite to make it more flexible in context of controller views
		// add additional argument to apply any plugin after rendering
		protoComponent._renderTemplate = function (templateElementName, context, ignoreAnimation) {
			var html = null;

			if (context) {
				html = this.templates[templateElementName](context);
			} else {
				html = this.templates[templateElementName](this.context);
			}
			if (ignoreAnimation) {
				this.elements[templateElementName].html(html);
			} else {
				this.elements[templateElementName].hide().html(html).fadeIn("fast");
			}
		};

		protoComponent.extend = function (component) {

			if (!component.context) component.context = {};

			$.extend(component.context, this.context);

			component.templates = app.templates[component.name];
			component.context.templates = component.templates;

			component.bindingsInitialized = false;

			component.__proto__ = this;

		};

		return protoComponent;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});